import {Link} from 'react-router-dom'
import './index.css'

const Home = () => (
    <div className='bg-container-main-app'>
    {/* <h1 className='homepage-title'>My React Projects<br/><span className='my-name'>- K S S PRATHYUSH</span></h1> */}
    <Link className='link-item' to='/IPLDashboard'>IPL Dashboard</Link><br/><br/>
    <Link className='link-item' to='/MiniPortfolio'>Mini Portfolio</Link><br/><br/>
    <Link className='link-item' to='/ApiBlogsFetch'>Blogs fetch through API</Link><br/><br/>
    <Link className='link-item' to='/GoogleSearchClone'>Google search clone</Link><br/><br/>
    <Link className='link-item' to='/SimpleFaqs'>Simple Faqs App</Link><br/><br/>
    <Link className='link-item' to='/AppStore'>App store Filtering</Link><br/><br/>
    <Link className='link-item' to='/InterviewQuestionsApp'>Interview Questions App</Link><br/><br/>
    </div>
)

export default Home